import { billingAmmounts } from '../../../const/billingAmmounts';

export function getDefaultAmount(amount) {
    return amount === undefined ? (billingAmmounts[0]?.value || 100) : (amount || 1);
}